<template>
  <customModal :containerxl="true" :bodyxl="true" :footerShow="true" @closeModal="closeModal">
    <template #title>
      <h4 class="my-0">{{ isEditMode ? 'Edit Key Risk Indicator' : 'Create Key Risk Indicator' }}</h4>
    </template>

    <template #body>
      <form>
        <div class="row">

          <!-- SECTION 1: General KRI Information -->
          <div class="col-12 mb-2">
            <h6 class="border-bottom py-1">General KRI Information</h6>
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">KRI ID <sup ><i class="fa fa-asterisk required"></i></sup></label>
            <input type="text" ref="kriId" class="form-control" v-model="form.kriId" :class="{ 'errorClass': errors.kriId }" :disabled="isEditMode" />
            <div class="errorClass" v-if="errors.kriId">{{ errors.kriId }}</div>
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">CTQ ID</label>
            <input type="text" class="form-control" v-model="form.ctqId" :disabled="ctqFieldsLocked" />
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">CTQ Factor</label>
            <input type="text" class="form-control" v-model="form.ctqFactor" :disabled="ctqFieldsLocked" />
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Risk ID</label>
            <input type="text" class="form-control" v-model="form.riskId" />
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Risk Indicator <sup ><i class="fa fa-asterisk required"></i></sup></label>
            <input type="text" class="form-control" v-model="form.riskIndicator" :class="{ 'errorClass': errors.riskIndicator }" />
            <div class="errorClass" v-if="errors.riskIndicator">{{ errors.riskIndicator }}</div>
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Core / Extended KRI</label>
            <select class="form-control" v-model="form.coreOrExtendedKRI">
              <option value="">Select Option</option>
              <option value="Core">Core</option>
              <option value="Extended">Extended</option>
            </select>
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">General / Specific</label>
            <select class="form-control" v-model="form.generalOrSpecific">
              <option value="">Select Option</option>
              <option value="General">General</option>
              <option value="Specific">Specific</option>
            </select>
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Type of Risk</label>
            <input type="text" class="form-control" v-model="form.typeOfRisk" />
          </div>

          <div class="col-lg-4 mb-2 d-flex align-items-center">
            <div class="d-flex align-items-center mt-4">
              <input type="checkbox" v-model="form.isActive" id="kriIsActive" class="mr-2" />
              <label class="mb-0" for="kriIsActive">Active</label>
            </div>
          </div>

          <!-- SECTION 2: Scrutiny & Metrics -->
          <div class="col-12 mt-3 mb-2">
            <h6 class="border-bottom py-1">Scrutiny & Metrics</h6>
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Frequency</label>
            <input type="text" class="form-control" v-model="form.frequency" />
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Scorecard</label>
            <input type="text" class="form-control" v-model="form.scorecard" />
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Weighting</label>
            <input type="text" class="form-control" v-model="form.weighting" />
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Unit</label>
            <input type="text" class="form-control" v-model="form.unit" />
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Data Source</label>
            <input type="text" class="form-control" v-model="form.dataSource" />
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Aggregation Level</label>
            <input type="text" class="form-control" v-model="form.aggregationLevel" />
          </div>

          <!-- SECTION 3: Narratives & Details -->
          <div class="col-12 mt-3 mb-2">
            <h6 class="border-bottom py-1">Narratives & Details</h6>
          </div>

          <div class="col-lg-6 mb-2">
            <label class="form-label mb-0">Discussion Details</label>
            <textarea class="form-control custom-textarea" rows="3" v-model="form.discussionDetails"></textarea>
          </div>

          <div class="col-lg-6 mb-2">
            <label class="form-label mb-0">Threshold Basis</label>
            <textarea class="form-control custom-textarea" rows="3" v-model="form.thresholdBasis"></textarea>
          </div>

          <div class="col-lg-12 mb-2">
            <label class="form-label mb-0">KRI Calculation Logic <sup ><i class="fa fa-asterisk required"></i></sup></label>
            <textarea ref="kriCalculationLogic" class="form-control custom-textarea" rows="3" v-model="form.kriCalculationLogic" :class="{ 'errorClass': errors.kriCalculationLogic }"></textarea>
             <div class="errorClass" v-if="errors.kriCalculationLogic">{{ errors.kriCalculationLogic }}</div>
          </div>
           
        </div>
      </form>
    </template>

    <template #footer>
      <div class="d-flex justify-content-end align-items-center">
        <div v-if="submitting" class="spinner-border text-primary spinner-border-sm me-3" role="status">
          <span class="visually-hidden">Saving...</span>
        </div>
        <button class="cancel_btn py-1 px-4 mx-2" :disabled="submitting" @click.prevent="clear">
          Clear
        </button>
        <button class="save_btn py-1 px-4" :disabled="submitting" @click.prevent="saveClicked">
          Save
        </button>
      </div>
    </template>
  </customModal>
</template>

<script src="./ManageKRIModal.js"></script>

<style scoped>
.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0;
}
.custom-textarea {
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 8px;
  resize: vertical;
}

</style>